"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Control = _interopRequireDefault(require("./Control.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _css = require("../css.js");

var _easing = require("../easing.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/control/Zoom
 */


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */

/**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */
var Zoom =
/** @class */
function (_super) {
  __extends(Zoom, _super);
  /**
   * @param {Options} [opt_options] Zoom options.
   */


  function Zoom(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      element: document.createElement('div'),
      target: options.target
    }) || this;
    var className = options.className !== undefined ? options.className : 'ol-zoom';
    var delta = options.delta !== undefined ? options.delta : 1;
    var zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
    var zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
    var zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
    var zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : "\u2013";
    var zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
    var zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
    var inElement = document.createElement('button');
    inElement.className = zoomInClassName;
    inElement.setAttribute('type', 'button');
    inElement.title = zoomInTipLabel;
    inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
    inElement.addEventListener(_EventType["default"].CLICK, _this.handleClick_.bind(_this, delta), false);
    var outElement = document.createElement('button');
    outElement.className = zoomOutClassName;
    outElement.setAttribute('type', 'button');
    outElement.title = zoomOutTipLabel;
    outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
    outElement.addEventListener(_EventType["default"].CLICK, _this.handleClick_.bind(_this, -delta), false);
    var cssClasses = className + ' ' + _css.CLASS_UNSELECTABLE + ' ' + _css.CLASS_CONTROL;
    var element = _this.element;
    element.className = cssClasses;
    element.appendChild(inElement);
    element.appendChild(outElement);
    /**
     * @type {number}
     * @private
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 250;
    return _this;
  }
  /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */


  Zoom.prototype.handleClick_ = function (delta, event) {
    event.preventDefault();
    this.zoomByDelta_(delta);
  };
  /**
   * @param {number} delta Zoom delta.
   * @private
   */


  Zoom.prototype.zoomByDelta_ = function (delta) {
    var map = this.getMap();
    var view = map.getView();

    if (!view) {
      // the map does not have a view, so we can't act
      // upon it
      return;
    }

    var currentZoom = view.getZoom();

    if (currentZoom !== undefined) {
      var newZoom = view.getConstrainedZoom(currentZoom + delta);

      if (this.duration_ > 0) {
        if (view.getAnimating()) {
          view.cancelAnimations();
        }

        view.animate({
          zoom: newZoom,
          duration: this.duration_,
          easing: _easing.easeOut
        });
      } else {
        view.setZoom(newZoom);
      }
    }
  };

  return Zoom;
}(_Control["default"]);

var _default = Zoom;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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